<template>
  <div class="home-skeleton">
    <div class="item" :style="{ backgroundColor: bg }">
      <!--  <shSkeleton bg="#e4e4e4" width="195px" height="120px" animated /> -->
      <shSkeleton bg="#e4e4e4" width="100vw" height="500px" animated />
      <!-- <shSkeleton bg="#e4e4e4" width="90px" height="24px" animated /> -->
    </div>
  </div>
</template>

<script>
export default {
  name: "HomeSkeleton",
  props: {
    bg: {
      type: String,
      default: "#fff",
    },
  },
};
</script>

<style scoped lang="less">
.home-skeleton {
  width: 100vw;
  height: 500px;
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  position: absolute;
  top: 0px;
  left: 0;
  .item {
    //width: 1240px;
    .sh-skeleton ~ .sh-skeleton {
      display: block;
    }
  }
}
</style>
